import { Box, Typography, CircularProgress } from '@mui/material';
export default function DetectStep() {
  return (
    <Box sx={{ textAlign: 'center', py: 6 }}>
      <CircularProgress sx={{ mb: 2 }} />
      <Typography variant="body1">Checking your sensor&hellip;</Typography>
    </Box>
  );
}
